import { render, staticRenderFns } from "./CheckPredict.vue?vue&type=template&id=483a8f31"
import script from "./CheckPredict.vue?vue&type=script&lang=js"
export * from "./CheckPredict.vue?vue&type=script&lang=js"
import style0 from "./CheckPredict.vue?vue&type=style&index=0&id=483a8f31&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports